
import { IssueAssembleResponse } from '../models/issue';
import { useI18n } from 'common-module/src/util/useI18n';
import { useInstance } from 'common-module/src/util/useInstance';
import { useVuex } from '../utils/useVuex';
import { markCommentMessageRead } from 'liga-detail-en/src/api/comment';
import { computed, ref, watch } from '@vue/composition-api';
import axios, { CancelTokenSource } from 'axios';

let issueInfoRequestCancel: CancelTokenSource | undefined;

import {
  getCreateIssueInfoWarper$,
  getIssueDetailObservable$
} from '../data/issue';
import { ActionStore, AllIssueDrawerAction } from './action';
import { ShareStore } from './share';
import { until } from '@vueuse/core';

export const useIssue = (
  actionStore: ActionStore,
  { isVisitor }: ShareStore
) => {
  const issueAssemble = ref<IssueAssembleResponse | null>(null);
  const instance = useInstance();
  const vuex = useVuex();
  const { t } = useI18n();

  const issueReport = (issueId: number, projectId: number) => {
    const dataId = issueId;
    const userId = vuex.state.user.account.userId;
    const eventGroupCode = 'layout';
    const eventGroupId = 7;
    const eventId = 7;
    instance.$track.send('issue_click', {
      eventGroupId,
      dataId,
      projectId,
      userId,
      eventGroupCode,
      eventId
    });
  };

  const isLoadComplete = ref(false);

  const refreshIssueDetail = async (
    action: AllIssueDrawerAction | null,
    force = false
  ) => {
    issueAssemble.value = null;
    isLoadComplete.value = false;

    try {
      if (action?.type === 'Edit') {
        issueInfoRequestCancel = axios.CancelToken.source();
        getIssueDetailObservable$(
          actionStore.localDb.value,
          action.issueId,
          action.force || force,
          {
            cancelToken: issueInfoRequestCancel.token
          }
        ).subscribe({
          next: (issue) => {
            if (
              action &&
              'issueId' in action &&
              issue.issueVO?.id === action.issueId
            ) {
              issueAssemble.value = issue;
            }
          },
          complete: () => {
            if (issueAssemble.value?.issueVO) {
              isLoadComplete.value = true;
              if (!isVisitor.value) {
                issueReport(
                  issueAssemble.value.issueVO.id,
                  issueAssemble.value.issueVO.projectId
                );
              }
            }
          },
          error: (e) => {
            if (e.deleteIssueExtendVO) {
              if (!e.deleteIssueExtendVO.showPerm) {
                // 被移出项目、组织后
                actionStore.close();
                instance.eventBus.$emit('permission-change', false);
                return;
              }
              const res = {
                ...e.deleteIssueExtendVO,
                id: action?.issueId
              };
              // issue被删除后 显示删除提示
              actionStore.markIssueIsDeleted(true, res);
              return;
            }
            actionStore.close();
          }
        });
      } else if (action?.type === 'Create' || action?.type === 'PreviewType') {
        getCreateIssueInfoWarper$(
          actionStore.localDb.value,
          action.projectId,
          action.issueTypeId,
          undefined,
          force
        ).subscribe({
          next: (issue) => {
            issueAssemble.value = issue;
          },
          complete: () => {
            isLoadComplete.value = true;
          }
        });
      }
    } catch (e: any) {
      if (e.deleteIssueExtendVO) {
        if (!e.deleteIssueExtendVO.showPerm) {
          // 被移出项目、组织后
          close();
          instance.eventBus.$emit('permission-change', false);
          return;
        }
        const res = {
          ...e.deleteIssueExtendVO,
          id: action?.issueId
        };
        // issue被删除后 显示删除提示
        actionStore.markIssueIsDeleted(true, res);
        return;
      }
      if (e && e.res?.code === '008') {
        // 被移出项目、组织后
        close();
        instance.eventBus.$emit('permission-change', false);
        return;
      }
      if (e.message) {
        instance.$message.error(e.message);
      }
    }
  };

  //等issueAssemble有值后再进行读消息
  const awaitDataMarkCommentMessageRead = async (reminderId: number) => {
    await until(isLoadComplete).toBe(true);
    markCommentMessageRead(reminderId);
  };

  watch(actionStore.action, (action) => refreshIssueDetail(action, false), {
    immediate: true
  });


  const isPin = computed(() => issueAssemble.value?.pinStatus === 1);

  actionStore.onClose(() => {
    issueInfoRequestCancel?.cancel();
  });

  return { issueAssemble, refreshIssueDetail, isPin, isLoadComplete, awaitDataMarkCommentMessageRead };
};
export type IssueStore = ReturnType<typeof useIssue>;
